import Link from 'next/link';
import React from 'react';
import type { ReactElement } from 'react';

import {
  Box,
  Button,
  Container,
  Grid,
  Illustration,
  Text,
} from '@mbank-design/design-system/components';
import { Spacing } from '@mbank-design/design-system/design-tokens';
import { BoxBackgroundColor, IllustrationSize } from '@mbank-design/design-system/enums';
import { Dolphin404Mass } from '@mbank-design/design-system/illustrations';

export default function Page(): ReactElement {
  return (
    <Box paddingY={[Spacing.SPACE_40, Spacing.SPACE_80]} background={BoxBackgroundColor.MONO_100}>
      <Container>
        <Grid>
          <Grid.Row>
            <Grid.Column span={[12, 10]} offset={[0, 1]}>
              <Box
                display="flex"
                flexDirection={['column-reverse', 'row']}
                justifyContent="space-between"
                alignItems="center"
              >
                <Box>
                  <Text as="h1" marginBottom={Spacing.SPACE_16}>
                    strona nie istnieje
                  </Text>
                  <Text marginBottom={Spacing.SPACE_24}>
                    Strona o takim adresie nie została odnaleziona.
                  </Text>
                  <Button component={Link} href="/">
                    powrót do strony głównej
                  </Button>
                </Box>
                <Illustration
                  illustrationComponent={Dolphin404Mass}
                  size={IllustrationSize.MEDIUM}
                />
              </Box>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Box>
  );
}
